import { useEffect, useRef } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { FriendPageWidget } from '@features/game/pages/FriendLobbyPage';
import { POOLS } from '@features/game/types/fast-game';

const querySchema = z.object({
  select: z.enum(POOLS).optional().catch(undefined),
});

export const Route = createFileRoute('/game/friend')({
  component: Page,
  validateSearch: querySchema,
});

function Page() {
  const { select } = Route.useSearch();
  const initialRef = useRef(select);
  const navigate = useNavigate();
  useEffect(() => {
    if (initialRef.current !== undefined) {
      navigate({ to: '/game/friend', replace: true, search: {} });
    }
  }, [navigate]);
  return <FriendPageWidget initialPool={initialRef.current} />;
}
